import { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatDateTime } from "@/lib/date";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function NotificationLogsPage() {
  const [logs, setLogs] = useState([]);
  const [channel, setChannel] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    const params = {};
    if (channel) params.channel = channel;
    if (status) params.status = status;
    api.get("/notification-logs", { params }).then((r) => setLogs(r.data || []));
  }, [channel, status]);

  return (
    <div className="space-y-4" data-testid="admin-notification-logs-page">
      <div>
        <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Administration</div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">Notification logs</h1>
        <p className="text-sm text-muted-foreground">Every attempt to deliver email or WhatsApp is logged here — including MOCKED sends while providers are disabled or in test mode.</p>
      </div>

      <div className="flex flex-wrap gap-3 items-center rounded-xl border border-border bg-card p-3">
        <Select value={channel} onValueChange={(v) => setChannel(v === "__all__" ? "" : v)}>
          <SelectTrigger data-testid="notif-logs-channel" className="w-40"><SelectValue placeholder="All channels" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="__all__">All channels</SelectItem>
            <SelectItem value="email">Email</SelectItem>
            <SelectItem value="whatsapp">WhatsApp</SelectItem>
          </SelectContent>
        </Select>
        <Select value={status} onValueChange={(v) => setStatus(v === "__all__" ? "" : v)}>
          <SelectTrigger data-testid="notif-logs-status" className="w-40"><SelectValue placeholder="All Status" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="__all__">All Status</SelectItem>
            <SelectItem value="sent">Sent</SelectItem>
            <SelectItem value="mocked">Mocked</SelectItem>
            <SelectItem value="failed">Failed</SelectItem>
            <SelectItem value="partial">Partial</SelectItem>
          </SelectContent>
        </Select>
        <div className="text-xs text-muted-foreground">{logs.length} entries</div>
      </div>

      <div className="rounded-xl border border-border bg-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="text-[11px] uppercase tracking-widest text-muted-foreground">
            <tr className="border-b border-border">
              <th className="text-left px-4 py-3">Time</th>
              <th className="text-left px-4 py-3">Channel</th>
              <th className="text-left px-4 py-3">To</th>
              <th className="text-left px-4 py-3">Subject / body</th>
              <th className="text-left px-4 py-3">Status</th>
              <th className="text-left px-4 py-3">Mock?</th>
              <th className="text-left px-4 py-3">Reason / error</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} data-row data-testid={`log-row-${l.id}`} className="border-b border-border/70">
                <td className="px-4 py-3 text-xs text-muted-foreground whitespace-nowrap">{l.created_at ? formatDateTime(l.created_at) : "—"}</td>
                <td className="px-4 py-3 text-xs font-mono uppercase">{l.channel}</td>
                <td className="px-4 py-3 text-xs">{Array.isArray(l.to) ? l.to.join(", ") : String(l.to || "")}</td>
                <td className="px-4 py-3 text-xs text-muted-foreground max-w-xl truncate">{l.subject || l.body}</td>
                <td className="px-4 py-3 text-xs">
                  <span className={`rounded-full border px-2 py-0.5 ${l.status === "sent" ? "text-emerald-700 border-emerald-500/30 bg-emerald-500/10" : l.status === "failed" ? "text-rose-700 border-rose-500/30 bg-rose-500/10" : "text-primary border-primary/30 bg-primary/10"}`}>
                    {l.status}
                  </span>
                </td>
                <td className="px-4 py-3 text-xs text-muted-foreground">{l.mock ? "Yes" : "—"}</td>
                <td className="px-4 py-3 text-xs text-rose-700/90 max-w-sm break-words">{l.error || "—"}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-muted-foreground text-xs">No notification logs yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
